export default {
    data() {
        return {
            eventBus: new Vue(),
            items: [],
            filters: {},
            meta: [],
            appliedFilters: [],
            sort: 'field_merk-ASC',
            page: 1,
        }
    },

    computed: {
        hasFilters() {
            return !_.isEmpty(this.filters);
        },

        hasGarage() {
          let garageFilter = _.find(this.appliedFilters, {
            'key': 'field_garage'
          });

          return !lodash.isNil(garageFilter);
        },

        selectedGarage() {
          let garageFilter = _.find(this.appliedFilters, {
            'key': 'field_garage'
          });
          return garageFilter;
        },

        showModelDropdown() {
            return (!lodash.isNil(this.filters.field_model) && this.filters.field_model.length > 1)
                || _.find(this.appliedFilters, {"key": "field_model"});
        }
    },

    mounted() {
        this.eventBus.$on('dropdown-changed', payload => {
            this.handleDropdownChanged(payload);
        });

        this.eventBus.$on('dropdown-emptied', payload => {
            this.handleDropdownEmptied(payload);
        });

        this.eventBus.$on('range-filter-changed', payload => {
            this.handleRangeFilterChanged(payload);
        });
    },

    methods: {
        handleDropdownChanged(payload) {
            let filter = _.find(this.appliedFilters, {
                'key': payload.filterKey
            });

            if (lodash.isNil(filter)) {
                this.appliedFilters.push({
                    key: payload.filterKey,
                    value: payload.value,
                    type: payload.type
                })
            }

            if (!lodash.isNil(filter)) {
                filter.value = payload.value;
            }

            this.page = 1;
            this.fetchData();
        },

        handleDropdownEmptied(payload) {
            let filter = _.find(this.appliedFilters, {
                'key': payload
            });

            if (payload === 'field_merk') {
                let modelFilter = _.find(this.appliedFilters, {
                    'key': 'field_model'
                });

                if (!lodash.isNil(modelFilter)) {
                    this.appliedFilters.splice(this.appliedFilters.indexOf(modelFilter), 1);
                }

                this.appliedFilters = [];

                this.eventBus.$emit('core-filter-changed');
            }

            if (payload !== 'field_merk') {
                this.appliedFilters.splice(this.appliedFilters.indexOf(filter), 1);
            }

            if(!lodash.isNil(window.defaultGarage)) {
                localStorage.setItem("appliedFilters", JSON.stringify(window.defaultGarage));
                this.appliedFilters = JSON.parse(localStorage.getItem('appliedFilters'));
            }

            this.page = 1;
            this.fetchData();
        },

        handleRangeFilterChanged(payload) {
            let filter = _.find(this.appliedFilters, {
                'key': payload.filterKey
            });

            if (lodash.isNil(filter)) {
                this.appliedFilters.push({
                    key: payload.filterKey,
                    min: payload.min,
                    max: payload.max,
                    type: payload.type
                })
            }

            if (!lodash.isNil(filter)) {
                filter.min = payload.min;
                filter.max = payload.max;
            }

            this.page = 1;
            this.fetchData();
        }
    },

    watch: {
        appliedFilters: {
            deep: true,
            handler(newFilterSet) {
                localStorage.removeItem('appliedFilters');
                localStorage.setItem('appliedFilters', JSON.stringify(newFilterSet));
            }
        }
    }
}
